<template>
  <div>
    <div class="page-container common-page" v-loading.fullscreen.lock="isLoading">
      <create-page :data="config.components" v-if="!isLoading"></create-page>
    </div>
    <div>
      <component ref="comp"
        v-if="!isLoading"
        :is="componentId"
        :tmplId="tmplId"
        @compAction="onCompAction"
        :tempData="tempObj"
      >
      </component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import CreatePage from "../../utils/commonPageVnodeCreate.js";
// import API from "../../libs/axios";
import "../../libs/element";

// function IsMobile(){
//   let userAgent = navigator.userAgent,Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
//   console.log('userAgent:',userAgent)
//   return Agents.some((i)=>{
//       return userAgent.includes(i)
//   })
// }
export default {
  name: "commonpage",
  components: {
    CreatePage,
  },
  data() {
    const pageNames = this.$route.path;
    console.log('pageNames----',pageNames)
    // const pageList = JSON.parse(localStorage.getItem('setPageConfigs'))
    // const pageConf = pageList.find(page => ((page.uri&&page.uri.includes(pageNames)) || (page.manual_url&&page.manual_url.includes(pageNames))));
    const pageConf = this.$store.getters.getConfigByPage(pageNames);
    this.checkLogin(pageConf.loginType)
    this.loadSettings(pageConf);
    let tmplId = null;
    const pageEndSetting = this.$store.state.dynamic.pageEndSetting;
    let tempObj = {}
    tempObj.pageEnd = this.$store.state.dynamic.pageEnd
    if (pageEndSetting == '1') {
      tmplId = 'tempFooter'
    } else {
      const theme = localStorage.getItem("theme")
      switch(theme){
        case "junmin":
          tmplId = 'junminFooter';
          break;
        case "yingji":
          tmplId = 'yingjiFooter';
          break;
        case "anquanshengchan":
          tmplId = 'anquanFooter';
          break;
        case "shandongjiaotong":
          tmplId = 'sdjtFooter';
          break;
        case "shanghaijiaoda":
          tmplId = 'shjdFooter';
          break;
        case 'sdjzmh2':
          tmplId = 'sdjz2Footer';
          break;
        case 'zhaohumh':
          tmplId = 'zhaohuFooter';
          break;
      }
    }
    return {
      isLoading: true,
      config: {},
      routerParams: {},
      pageEndSetting,
      tmplId,
      componentId: null,
      tempObj
    };
  },
  provide() {
    return {
      isDebug: this.$route.query.is_debug === "1973",
    };
  },
  computed: {
    ...mapGetters(["storeGetPageSetData"]),
  },
  watch: {
    $route() {
      const { params } = this.$route.query;
      const { path } = this.$route;
      console.log('path----',path)
      this.config = this.$store.getters.getConfigByPage(path);
      this.routerParams = params;
      this.render();
    },
  },
  beforeCreate () {
    // document.querySelector('body').setAttribute('style', 'background-color:#ffffff;')
    // let state = IsMobile();
    // console.log('state------->',state,this.$route.path)
    // let _href = this.$store.state.dynamic.pageSetData.solutionInfo.domain.filter( (item)=>{ return item.frontend_template_id = 4} ) //配置的路由
    // let _hrefDomain =  Array.isArray(_href)? _href[1].domain : _href.domain; //h5路由
    // let isAutoRedirect = JSON.parse(this.$store.state.dynamic.pageSetData.frontendConfig.filter((item)=>{ return item.key ==='is_auto_redirect'})[0].value); //是否需要pc跳转显示H5
    // let isHomepage = this.$store.state.dynamic.pageSetData.frontendConfig.filter((item)=>{ return item.key ==='homepage'})[0].value; //首页路由
    // console.log('state------》888',state,this.$route.path.split('/')[1] === isHomepage,isAutoRedirect,_hrefDomain)
    // if(state && this.$route.path.split('/')[1] === isHomepage && isAutoRedirect){ // 是否移动端 ，是否首页,是否配置PC跳转显示 h5
    //   console.log('ok----')
    //   window.location.href = `https://${_hrefDomain}`
    // }
    const pageBackgroundSetting = this.$store.state.dynamic.pageBackgroundSetting;
    document.querySelector('body').setAttribute('style', `background-color:${pageBackgroundSetting?pageBackgroundSetting.replace(/"/g,""):'rgba(255,255,255,1)'}`)
  },
  created() {
    const { params } = this.$route.query;
    const { path } = this.$route;
    this.config = this.$store.getters.getConfigByPage(path);
    this.routerParams = params;
    this.render();
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    loader(tempName) {
      let templatData={}
      try {
        // const footerTamplate = require.context("../../../src/modules/dynamic/components", true, /.vue$/); //测试路由
        const footerTamplate = require.context("../../../../../../src/modules/dynamic/components", true, /.vue$/);
        footerTamplate && footerTamplate.keys().forEach(async (key) => {
          let templateName = (key.split('.')[key.split('.').length-2]).split('/')[1];
          const el = footerTamplate(key).default
          templatData[templateName] = el
        });
      } catch (error) {
          console.log('自定义目录---->src/modules/dynamic/components不存在',error)
      }
      return templatData[tempName]
    },
    ...mapMutations(["storeSetPageSettings"]),
    loadSettings(pageConf) {
      setTimeout(()=>{
            this.storeSetPageSettings(pageConf.blockContent.blockList);
            this.isLoading = false
      },300)
    },
    checkLogin(type) {
      let token = localStorage.getItem('token');
      if (type == '1' && !token) {
        this.$router.push({ path: "/login"});
        return
      }
    },
    render() {
      this.componentId = this.loader(this.tmplId)
      // this.componentId = this.loader('test') //测试
    },
    onCompAction(data) {
      this.$emit('compAction', data);
    }
  },
};
</script>
<style lang="stylus" scoped>
.page-container {
  // width: 1200px;
  margin: 0 auto;
}
/**一分栏  二分栏 选项卡  样式*/
/deep/ div[data-comp-name="12-12"], /deep/ div[data-comp-name="1-2"], /deep/ div[data-comp-name="Tabs"]{
  width:1200px;
  margin: 0 auto;
}
/deep/ .el-row{
  margin:0 auto;
  background-position: center 0;
  background-repeat: no-repeat;
}
/* *
// .page-container {
//   margin: 0 auto;
//   margin-top: 24px;
//   .isroot{
//     margin:0 auto;
//     > .el-col-24{
//       width:100%;
//       > .el-row{

//             width:1200px;
//             margin:0 auto;

//       }
//     }
//   }
// }
* */
</style>
